module.exports = __webpack_public_path__ + "static/img/logo-4.2f40e862.png";